import { getProjectFlavourLabel, getTaskFlavourLabel } from '~/utils/project_flavour';

export function projectFlavourLabel(flavour, plural = false) {
  return getProjectFlavourLabel(flavour, plural);
}

export function taskFlavourLabel(flavour, plural = false) {
  return getTaskFlavourLabel(flavour, plural);
}
